import stickybits from 'stickybits';
import { Component } from '@opten/gin-tonic/helpers/compiler';

@Component({ className: 'js-sticky-services-title' })
export class StickyServicesTitleComponent {
	offset: number;
	currentOffset: number;
	stickyElement: any;

	constructor(private element: HTMLElement) {
		this.offset = 71;
		this.currentOffset = window.outerWidth < 1200 ? 0 : this.offset;

		this.stickyElement = stickybits(this.element, {
			parentClass: 'js-sticky-parent',
			stickyChangeClass: 'is-sticky-change',
			stickyClass: 'is-sticky',
			stuckClass: 'is-stuck',
			stickyBitStickyOffset: this.currentOffset,
			useStickyClasses: true
		});
		window.addEventListener('resize', () => this.updateSticky());
	}

	updateSticky() {
		let updateStickybits = false;
		if (window.outerWidth < 1200) {
			if(this.currentOffset != 0){
				updateStickybits = true;
				this.currentOffset = 0;
			}
		}
		else{
			if(this.currentOffset != this.offset){
				updateStickybits = true;
				this.currentOffset = this.offset;
			}
		}
		if(updateStickybits){
			this.stickyElement.update({
				stickyBitStickyOffset: this.currentOffset
			});
		}
	}
}
